var React = require('react');

function IcAwsOpsworksMonitoring (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Art"},React.createElement("g",null,React.createElement("path",{"className":"st0","d":"M39.149,34.817H0.851c-0.47,0-0.851-0.38-0.851-0.851V23.591c0-0.194,0.066-0.381,0.187-0.532l9.574-11.966\n\t\t\tc0.276-0.344,0.769-0.421,1.137-0.176l8.95,5.967l9.884-11.408c0.15-0.173,0.364-0.279,0.593-0.292\n\t\t\tc0.235-0.017,0.454,0.065,0.623,0.22l8.774,7.983c0.177,0.161,0.278,0.39,0.278,0.63v19.949\n\t\t\tC40,34.437,39.619,34.817,39.149,34.817z M1.702,33.115h36.596V14.394L30.447,7.25l-9.804,11.316\n\t\t\tc-0.28,0.324-0.759,0.389-1.115,0.151l-8.925-5.95l-8.9,11.123v9.225H1.702z"}))));
}

IcAwsOpsworksMonitoring.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 40 40","style":{"enableBackground":"new 0 0 40 40"},"xmlSpace":"preserve"};

module.exports = IcAwsOpsworksMonitoring;

IcAwsOpsworksMonitoring.default = IcAwsOpsworksMonitoring;
